<template>
    <!-- Players' top bar on the question/feedback screens: fullscreen on the
         left (away from logout, so neither gets pressed by mistake), the
         stage progress in the middle (slot), logout on the right.
         .activity-topbar is styled further by assets/scss/event-design.scss. -->
    <div class="activity-topbar player-topbar" :class="{ 'activity-topbar-timer': timer }">
        <FullScreen btn_class="btn btn-sm btn-outline-light player-topbar-btn event-icon-btn" />
        <div class="player-topbar-main">
            <slot></slot>
        </div>
        <button type="button" class="btn btn-sm btn-outline-light player-topbar-btn" title="Cerrar sesión" aria-label="Cerrar sesión" @click="logout"><i class="bi bi-box-arrow-left"></i></button>
    </div>
</template>

<script>
import FullScreen from '@/components/FullScreen.vue'
import utils from '@/../../shared/utils'

export default {
    name: 'PlayerTopbar',
    components: { FullScreen },
    props: {
        // Activity.vue's countdown badge hangs over the bar's bottom edge -
        // only then does the bar need the extra bottom room for it.
        timer: { type: Boolean, default: false },
    },
    methods: {
        logout(){
            utils.reset_client();
        }
    }
}
</script>

<style scoped>
    .player-topbar{
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 6px 14px;
        background-color: var(--vc-ink-900);
        flex-shrink: 0;
    }
    .player-topbar-main{
        flex: 1;
        min-width: 0;
    }
    .player-topbar-btn{
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        padding: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    @media (min-width: 768px){
        .player-topbar{
            padding: 8px 24px;
            gap: 14px;
        }
    }
</style>
